import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store/index';
import { BrowserRouter } from 'react-router-dom';
import { siteService } from './utility/products';
import { useState } from 'react';

const Root = () => {
  const [sites, setSites] = useState([]);
  useEffect(() => {
    try {
      async function fetchData() {
        const response = await siteService
          .getSites();
        setSites(response)
      }
      fetchData();
    } catch (error) {
      // Trate o erro
    }
  }, []);

  return (
    <React.StrictMode>
      <BrowserRouter basename={"/"}>
        <Provider store={store}>
          <App sites={sites} />
        </Provider>
      </BrowserRouter>
    </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Root />
);
